export const tourFunctions = {}
/*____________ Tour Functions ____________*/

tourFunctions.convertColor = (color) => {
  color = color || "0x000000";
  if (color.startsWith('#')) {
    color = '0x' + color.slice(1);
  }
  return color;
}

tourFunctions.getScenes = () => {
  const scenes = window.CC.krpano.get('scene').getArray();
  return scenes;
}

tourFunctions.switchView = () => {
    expandedTour = !expandedTour
    expandedMap = !expandedMap
    expandedTour ? showHotspots() : hideHotspots();
    setMapZoom();
}

tourFunctions.setMapZoom = () => {
    let zoomExpandedMap = 16.75
    let zoomMiniMap = 15
    let zoomLevel = expandedMap ? zoomExpandedMap : zoomMiniMap
    tourFunctions.mapZoom.set(zoomLevel);
    return zoomLevel;
}

tourFunctions.showHotspots = () => {
    console.log('show_hotspots')
    window.CC.krpano.call('show_hotspots');
}

tourFunctions.hideHotspots = () => {
    console.log('hide_hotspots')
    window.CC.krpano.call('hide_hotspots');
}

tourFunctions.nextScene = () => {
    window.CC.krpano.call('nextscene_loop(+1)')
}

tourFunctions.prevScene = () => {
    window.CC.krpano.call('nextscene_loop(-1)')
}

tourFunctions.loadScene = (scene) => {
    let sceneName = typeof scene === 'string' ? scene : scene.name;
    window.CC.krpano.call(`loadscene(${sceneName}, NULL, MERGE, SLIDEBLEND(0.5, 90, 0.2, linear) )`)
}

tourFunctions.parseContent = (content) => {
  if (typeof content !== 'string') { return ""; }
  return content
      .replaceAll('[', '<')
      .replaceAll(']', '>')
}

tourFunctions.getFirstScene = () => {
    return window.CC.krpano.get('scene[0]');
}

tourFunctions.getFirstSceneName = () => {
    return window.CC.krpano.get('scene[0].name');
}

tourFunctions.currentScene = {
    getTitle: () => {
      return window.CC.krpano.get('scene[get(xml.scene)].title')
    },
    getScene: () => {
        return window.CC.krpano.get('scene[get(xml.scene)]')
    },

    getName: () => {
        return window.CC.krpano.get('xml.scene')
    },

    getIndex: () => {
        return window.CC.krpano.get('scene[get(xml.scene)].index')
    },

    getHotspots: () => {
        let validStyles = [
            'skin_hotspotstyle', 
            'skin_hotspotstyle_balloon',
        ]

        let hotspots = 
            window.CC.krpano.get('hotspot').getArray()
            .filter((hs)=>{
                return validStyles.includes(hs.style)
            })
        
        return hotspots;
    },

    getHotspot: (name) => {
        return window.CC.krpano.get(`hotspot[${name}]`)
    },

    getGallery: (name) => {
        let galleryObj = window.CC.krpano.get(`gallery[${name}]`)
        let gallery = galleryObj.img.getArray().map((galleryImg)=>{
            return galleryImg.url.replace('%SWFPATH%', '.');
        })
        return gallery;
    },


    removeHotspot: (hs) => {
        window.CC.krpano.call('removehotspot(' + hs.name + ')');
    },

    getContent: () => {
        return window.CC.krpano.get('xml').content
    },

    getLogo: () => {
        return window.CC.krpano.get('scene[get(xml.scene)].logo')
    },

    getView: () => {
        return window.CC.krpano.get('xml.view');
    },

    getCurrentView: () => {
        return window.CC.krpano.get('view')
    },

    getPosition: () => {
        let view = tourFunctions.currentScene.getCurrentView();
        let position = { ath: view.hlookat, atv: view.vlookat }
        return position;
    },
}

tourFunctions.setupColors = (colors) => {
    for(let key in colors){
        let rgb = hexToRgbString(colors[key])
        let hex = hexToString(colors[key])

        setStyleVar(kebabCase(key)+'-rgb', rgb);
        setStyleVar(kebabCase(key), hex);
        
        colors[key+'Rgb'] = rgb;
        colors[key+'Hex'] = hex;
    }
}

// Private functions
function hexToRgb(hex) {
  let r = hex >> 16;
  let g = hex >> 8 & 0xFF;
  let b = hex & 0xFF;
  return [r,g,b];
}

function rgbToString(rgb){
    return +rgb[0]+','+rgb[1]+','+rgb[2];
}

function hexToRgbString(hex) {
    let rgb = hexToRgb(hex);
    return rgbToString(rgb);
}

function hexToString(hex) {
  // if hex is a string (ie from json response)
  if (typeof hex === 'string') {
    hex = parseInt(hex, 16);
  }
  // convert hex to string
  let str = hex.toString(16);
  // pad with leading zeros
  while (str.length < 6) { str = '0' + str; }
  // #rrggbb
  return '#' + str.toUpperCase();
}

function setStyleVar(name, value){
    if(!name.startsWith('--')){ name = '--' + name; }
    document.documentElement.style.setProperty(name, value);
}

function kebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
